import { Util } from "./util.js";

const util = new Util();
const DEFAULT_COMBO_INFO_FOR_ARTICLE = Object.freeze({ comboType: "UNKNOWN" });

export class WishlistHeartV1 {
	constructor(
		articleDom,
		className,
		wishlist,
		variationId,
		comboInfoForArticle = DEFAULT_COMBO_INFO_FOR_ARTICLE,
		isArticleInTopicPage = false
	) {
		this.articleDom = articleDom;
		this.variationId = variationId;
		this._variationsForArticle = JSON.parse(util.readFromDataAttribute(articleDom, "variation_ids"));
		this.comboType =
			comboInfoForArticle.comboType.charAt(0).toUpperCase() +
			comboInfoForArticle.comboType.slice(1).toLowerCase();
		this.isArticleInTopicPage = isArticleInTopicPage;
		this._className = className;
		this._setWishlistHeartDomState(className);
		this.wishlist = wishlist;
	}

	_setWishlistHeartDomState() {
		this._wishlistHeartDom = this.articleDom.querySelector("." + this._className);
		this._onWishlist = this._wishlistHeartDom.getAttribute("icon") === "wishlist-active";

		if (this._onWishlist) {
			this._wishlistHeartDom.ocAriaLabel = "Artikel vom Merkzettel entfernen";
			this._wishlistHeartDom.icon = "wishlist-active";
		} else {
			this._wishlistHeartDom.ocAriaLabel = "Artikel merken";
			this._wishlistHeartDom.icon = "wishlist";
		}
	}

	addClickHandlerForWishlistBtn() {
		this.wishlistHeartDom.addEventListener("click", this._toggleHeartWishlistHeartOnClick());
	}

	_toggleHeartEnabled(heartBtn, enabled, initialSetup) {
		const defaultClasses = this._className;
		if (!initialSetup) {
			if (enabled) {
				/*                                                      */
				heartBtn.className = defaultClasses;
				heartBtn.selected = true;
				heartBtn.icon = "wishlist-active";
				heartBtn.iconColor = "var(--oc-semantic-color-brand)";
				heartBtn.ocAriaLabel = "Artikel vom Merkzettel entfernen";
			} else {
				heartBtn.className = defaultClasses;
				heartBtn.selected = false;
				heartBtn.icon = "wishlist";
				heartBtn.iconColor = "revert-layer";
				heartBtn.ocAriaLabel = "Artikel merken";
			}
		} else if (enabled) {
			heartBtn.className = defaultClasses;
			heartBtn.selected = false;
			heartBtn.icon = "wishlist";
			heartBtn.iconColor = "revert-layer";
			heartBtn.ocAriaLabel = "Artikel merken";
		}
	}

	_toggleHeartWishlistHeartOnClick() {
		return async event => {
			event.stopPropagation(); /*                                                       */
			this.onWishlist = !this.onWishlist;
			this._toggleHeartEnabled(this.wishlistHeartDom, this.onWishlist, false);
			const addedFrom = this._getWishListAddEventAddedFrom(this);
			if (this.onWishlist) {
				await this.wishlist.addItem(this.variationId, this.variationsForArticle.length === 1, addedFrom);
			} else {
				this.variationsForArticle.map(async variationId => {
					await this.wishlist.deleteItem(variationId, addedFrom);
				});
			}
		};
	}

	_getWishListAddEventAddedFrom(self) {
		return self.isArticleInTopicPage ? `SingleComboTopic` : `SingleCombo${self.comboType}`;
	}

	get variationsForArticle() {
		return this._variationsForArticle;
	}

	get onWishlist() {
		return this._onWishlist;
	}

	set onWishlist(value) {
		this._onWishlist = value;
	}

	get wishlistHeartDom() {
		return this._wishlistHeartDom;
	}
}
